import React from 'react'
import Spacer from '../../../components/Spacer';
import Banner from '../../../components/Banner';
import BannerAdhere from './BannerAdhere';
import Info from './Info';


function Adhere() {
  const text1 = `
    IDECABA es una plataforma que busca integrar a las organizaciones públicas o privadas
que producen y trabajan con información geoespacial y se interesan en publicar sus datos
para mejorar el acceso a la información y afianzar la gobernanza de datos, tanto dentro
como fuera de Gobierno.
  `;
  const text2 = `
  Para formar parte se requiere completar una Carta de Adhesión a IDECABA y enviarla por
  correo electrónico a 
`;

  return (
    <>
    <Banner titleSection={'¿COMO ADHERIRSE A IDECABA?'} linkName={'Inicio'} nameSection={'¿Como adherirse a IDECABA?'} />
    <Spacer/>
    <BannerAdhere/>
    <Spacer/>
    <Info text={text1}/>
    <Spacer/>
    <Info text={text2} email={'idecaba@buenosaires.gob.ar'}/>
    <Spacer/>
    </>
  )
}

export default Adhere